import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const LoginWrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #181c21;
  color: #fff;
  position: relative;

  .title {
    font-size: 2em;
  }

  .loader {
    margin-top: 50px;
  }
  .login-message {
    font-weight: 500;
    font-size: 17px;
  }
`;
